import { setActiveEventId } from "@client/actions";
import { eventIdSelector, makeFieldStyleSelector } from "@client/content/modules/selectors";
import { type RootContainerProps } from "@client/content/types";
import { globals } from "@client/globals";
import { type AppState } from "@client/types";
import { connect } from "react-redux";
import { fetchPage, search, setFilter } from "../../actions";
import {
  localStateSelector,
  makeCategoryIdSelector,
  makeFilterOrderBySelector,
  makeFilterPageSizeSelector,
  makeFilterSearchTextSelector
} from "../../selectors";
import Component, { type ProductListFiltersActionProps, type ProductListFiltersMapProps } from "./component";
import { eventOptionsSelector, makeCategoryOptionsSelector } from "./selectors";

const makeMapStateToProps = () => {
  const categoryIdSelector = makeCategoryIdSelector();
  const categoryOptionsSelector = makeCategoryOptionsSelector();
  const fieldStyleSelector = makeFieldStyleSelector();
  const orderSelector = makeFilterOrderBySelector();
  const pageSizeSelector = makeFilterPageSizeSelector();
  const searchTextSelector = makeFilterSearchTextSelector();

  return (state: AppState, props: RootContainerProps): ProductListFiltersMapProps => {
    const { orders } = localStateSelector(state, props);
    return {
      categoryOptions: categoryOptionsSelector(state, props),
      categoryId: categoryIdSelector(state, props),
      eventId: eventIdSelector(state) ?? null,
      events: eventOptionsSelector(state),
      fieldStyle: fieldStyleSelector(state, props),

      isEventsVisible: !state.portal.eventId && globals.siteInfo.brandKey === "Expomarket",
      orders,
      order: orderSelector(state, props),
      pageSize: pageSizeSelector(state, props),
      screenType: state.viewport.screen,
      searchText: searchTextSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ProductListFiltersActionProps => ({
  onCategoryIdChange: (categoryId: string | null) => {
    dispatch(setFilter(props.id, "categoryId", categoryId));
    dispatch(fetchPage({ id: props.id, source: props.source, page: 1 }));
  },
  onEventChange: (eventId: string | null) => {
    dispatch(setActiveEventId(eventId));
    dispatch(fetchPage({ id: props.id, source: props.source, page: 1 }));
  },
  onOrderByChange: (order: string) => {
    dispatch(setFilter(props.id, "order", order));
    dispatch(fetchPage({ id: props.id, source: props.source, page: 1 }));
  },
  onPageSizeChange: (pageSize: number) => {
    dispatch(setFilter(props.id, "pageSize", pageSize));
    dispatch(fetchPage({ id: props.id, source: props.source, page: 1 }));
  },
  onSearch: () => dispatch(search({ id: props.id, source: props.source })),
  onSearchTextChange: (searchText: string) => dispatch(setFilter(props.id, "searchText", searchText))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
